export var GroupPrivacyLevel;
(function (GroupPrivacyLevel) {
    GroupPrivacyLevel["SECRET"] = "SECRET";
    GroupPrivacyLevel["PRIVATE"] = "PRIVATE";
    GroupPrivacyLevel["PUBLIC"] = "PUBLIC";
})(GroupPrivacyLevel || (GroupPrivacyLevel = {}));
export var Type;
(function (Type) {
    Type["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    Type["PAID_PLANS"] = "PAID_PLANS";
    Type["EVENTS"] = "EVENTS";
})(Type || (Type = {}));
export var RoleInGroup;
(function (RoleInGroup) {
    RoleInGroup["GROUP_ADMIN"] = "GROUP_ADMIN";
    RoleInGroup["GROUP_MEMBER"] = "GROUP_MEMBER";
    RoleInGroup["SITE_ADMIN"] = "SITE_ADMIN";
})(RoleInGroup || (RoleInGroup = {}));
export var FailedPrecondition;
(function (FailedPrecondition) {
    FailedPrecondition["UNKNOWN"] = "UNKNOWN";
    FailedPrecondition["UNKNOWN_QUESTION_IDS"] = "UNKNOWN_QUESTION_IDS";
    FailedPrecondition["REQUIRED_ANSWERS_MISSING"] = "REQUIRED_ANSWERS_MISSING";
    FailedPrecondition["ANSWERS_MISSING"] = "ANSWERS_MISSING";
})(FailedPrecondition || (FailedPrecondition = {}));
export var JoinGroupPrecondition;
(function (JoinGroupPrecondition) {
    JoinGroupPrecondition["UNKNOWN"] = "UNKNOWN";
    JoinGroupPrecondition["UNKNOWN_QUESTION_IDS"] = "UNKNOWN_QUESTION_IDS";
    JoinGroupPrecondition["REQUIRED_ANSWERS_MISSING"] = "REQUIRED_ANSWERS_MISSING";
    JoinGroupPrecondition["ANSWERS_MISSING"] = "ANSWERS_MISSING";
})(JoinGroupPrecondition || (JoinGroupPrecondition = {}));
export var RelationshipWithGroup;
(function (RelationshipWithGroup) {
    RelationshipWithGroup["NONE"] = "NONE";
    RelationshipWithGroup["JOINED"] = "JOINED";
    RelationshipWithGroup["PENDING_APPROVAL"] = "PENDING_APPROVAL";
    RelationshipWithGroup["REJECTED_MEMBERSHIP"] = "REJECTED_MEMBERSHIP";
})(RelationshipWithGroup || (RelationshipWithGroup = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var RoleFilter;
(function (RoleFilter) {
    RoleFilter["UNKNOWN"] = "UNKNOWN";
    RoleFilter["GROUP_MEMBER"] = "GROUP_MEMBER";
    RoleFilter["GROUP_ADMIN"] = "GROUP_ADMIN";
})(RoleFilter || (RoleFilter = {}));
export var Set;
(function (Set) {
    Set["PUBLIC"] = "PUBLIC";
    Set["ALL"] = "ALL";
})(Set || (Set = {}));
export var ItemsFilter;
(function (ItemsFilter) {
    /** get only items which are listed in request */
    ItemsFilter["BY_ID"] = "BY_ID";
    /** get all items */
    ItemsFilter["ALL_ITEMS"] = "ALL_ITEMS";
})(ItemsFilter || (ItemsFilter = {}));
//# sourceMappingURL=types.impl.js.map